import { render, staticRenderFns } from "./BaseHorizontalLoader.vue?vue&type=template&id=238af06b&scoped=true"
import script from "./BaseHorizontalLoader.vue?vue&type=script&lang=js"
export * from "./BaseHorizontalLoader.vue?vue&type=script&lang=js"
import style0 from "./BaseHorizontalLoader.vue?vue&type=style&index=0&id=238af06b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "238af06b",
  null
  
)

export default component.exports